import { NotificationMechanism } from '@api/devicetypes/DeviceTypeAPI';
import { DeviceUpdateStatus, UpdateStatus } from '@api/updates/UpdatesAPI';
import TableRow from '@components/ui/layout/TableLayout/Row/TableRow';
import TextEntry from '@components/ui/layout/TableLayout/Text/TextEntry';
import React from 'react';

interface IDetailedUpdateRow {
    status: DeviceUpdateStatus;
    possibleStatuses: UpdateStatus[];
    notificationMechanisms: NotificationMechanism[];
}

const DetailedUpdateRow: React.FunctionComponent<IDetailedUpdateRow> = ({ status, possibleStatuses, notificationMechanisms }) => {
    return (
        <TableRow>
                <div><TextEntry label={status.correlation_id}></TextEntry></div>
                <div><TextEntry label={possibleStatuses.find(n => n.id === status.state)?.name || ''}></TextEntry></div>
                <div><TextEntry label={status.utc_timestamp}></TextEntry></div>
                <div><TextEntry label={(status.attempts)? status.attempts.toString(): ''}></TextEntry></div>
                <div><TextEntry label={status.additional_data}></TextEntry></div>
        </TableRow>
    );
}

export default DetailedUpdateRow;